import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { AppHeader } from '@/layouts/components/AppHeader';
import { AppSider } from '@/layouts/components/AppSider';
import type { MenuProps } from 'antd';

const { Content } = Layout;

interface BaseAppLayoutProps {
  menuItems: MenuProps['items'];
}

export function BaseAppLayout({ menuItems }: BaseAppLayoutProps) {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader />
      <Layout>
        <AppSider items={menuItems} />
        <Layout style={{ padding: 24 }}>
          <Content
            style={{
              padding: 24,
              background: '#fff',
              borderRadius: 8,
              minHeight: 360,
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}
